import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { REQUEST_ORDER_UPDATE } from "./RequestOrderUpdate";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { handleVmGraphQLErrors } from "./util/httpRequestUtil";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { useQueryParams } from "./util/routerUtil";
import { useRudderStackAnalytics } from "../useAnalytics";

/**
 * React component to handle order update requests that come from
 * the order created email.
 */
export default function OrderUpdateRequested() {
  const analytics = useRudderStackAnalytics();

  const [requestOrderUpdate, { loading, data, error }] = useMutation(
    REQUEST_ORDER_UPDATE,
    {
      fetchPolicy: "no-cache",
    },
  );
  const success = data?.requestOrderUpdate;

  const queryParams = useQueryParams();
  const orderNumber = queryParams.get("order_number") ?? "";
  const patientName = queryParams.get("patient_name") ?? "";
  const token = queryParams.get("token") ?? "";

  useEffect(() => {
    requestOrderUpdate({
      variables: {
        orderNumber: orderNumber,
        patientName: patientName,
        fromEmail: true,
        token: token,
      },
    });
  }, []);

  if (loading) {
    return (
      <div className="tw-mx-auto tw-my-[25px] tw-flex tw-w-1/3 tw-justify-center">
        <FontAwesomeIcon className="fa-pulse" icon={faSpinner} size="3x" />
      </div>
    );
  } else {
    return (
      <div className="tw-mx-auto tw-my-[25px] tw-w-1/3 tw-text-center tw-text-zinc-700">
        <div className="tw-my-[40px]">
          {success ? (
            <>
              <p className="tw-text-[19px] tw-font-bold">
                {`We've received your request for an order update for order #${orderNumber} (${patientName})`}
              </p>
              <p>
                We'll call the patient to check in with them and email you the
                notes from the call.
              </p>
            </>
          ) : (
            <>
              <div className="tw-flex tw-flex-col tw-justify-center">
                <div>
                  <h1 className="tw-my-[13px] tw-font-bold tw-text-orange-1">
                    Oops! Something went wrong.
                  </h1>
                </div>
                <div className="tw-mb-[35px] tw-flex tw-justify-center">
                  {error ? handleVmGraphQLErrors(error.message) : null}
                </div>
                <div>
                  <p className="tw-text-[19px] tw-text-orange-1">
                    Please try again.
                  </p>
                </div>
                <div className="tw-m-[5px]">
                  <StandardButton
                    style="primary-blue"
                    onClick={() => {
                      requestOrderUpdate({
                        variables: {
                          orderNumber: orderNumber,
                          patientName: patientName,
                          fromEmail: false,
                          token: token,
                        },
                      });
                      analytics?.track("Request Order Update");
                    }}
                  >
                    Request order update
                  </StandardButton>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
